import { v4 as uuid } from 'uuid';

/**
 * Generates a UUID that can be used as a unique key rendering React elements from iterables.
 */
export const generateUniqueKey = (): string => uuid();
